import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  justify-content: space-between;
  background-color: #fff1cc;
  align-items: flex-end;
  margin: 50px 0px 12px;

  border-radius: 16px;
  position: relative;
  padding: 5px 10px;

  display: flex;
  height: 32px;
  width: 100%;

  > span:first-child {
    font-weight: ${Theme.font.weight.regular};
    font-size: ${Theme.rems(16)};

    position: absolute;
    line-height: 22px;

    top: -36px;
    left: 0px;
  }
`;

export const Track = styled.div`
  transform: translateY(-50%);
  border-radius: 16px;
  position: absolute;
  overflow: hidden;

  height: 32px;
  width: 100%;
  left: 0px;
  top: 50%;
`;

export const WrapTrack = styled.div`
  transform: translateY(-50%);

  position: absolute;
  overflow: hidden;

  height: 56px;
  width: 100%;

  top: 50%;
  left: 0;
`;

type ButtonAttributes = {
  $currentValue: number;
  $value: number;
};

const getColorButton = (currentValue: number, value: number) =>
  currentValue === value ? Theme.color.brown : Theme.color.orange;

export const Icon = styled.span(
  ({ $value = 0, $currentValue = 0 }: ButtonAttributes) => css`
    color: ${getColorButton($currentValue, $value)};

    background-color: none;
    pointer-events: none;

    position: relative;
    line-height: 0px;

    padding: 0px;
    z-index: 3;
  `
);

type ButtonMarkerAttributes = {
  $value?: number;
};

const calcX = (value: number) =>
  !value
    ? `calc(32px - ${100 - value}%)`
    : value === 50
    ? `calc(16px - ${100 - value}%)`
    : `${100 - value}%`;

export const ButtonMarker = styled.div(
  ({ $value = 0 }: ButtonMarkerAttributes) => css`
    transform: translateX(${calcX($value)});
    transition: transform 0.25s;
    position: absolute;

    height: 100%;
    width: 100%;

    left: 0;
    top: 0;

    &::before {
      background-color: ${Theme.color.orange};
      border-radius: 16px;
      position: absolute;

      height: 56px;
      width: 32px;
      content: '';

      z-index: 2;
      right: 0;
      top: 0;
    }
  `
);
